export default __webpack_public_path__ + "static/media/diners.5e04a766.svg";